import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Machine from "./components/machine/Machine";
import Main from "./components/main/Main";


const App =() =>{
  return(
    <div>
      <Header/>
      <Main/>
      <Machine/>
      <Footer/>
    </div>
  )
};

export default App;
